export const BASE_ASSETS = `${process.env.PUBLIC_URL}/assets/animations`;
export const AVATAR_ANIMATION = `${BASE_ASSETS}/man.json`;
export const DASHBOARD_ANIMATION = `${BASE_ASSETS}/dashboard.json`;
export const WARNING_ANIMATION = `${BASE_ASSETS}/warning.json`;
export const CHECK_ANIMATION = `${BASE_ASSETS}/check.json`;
export const PLAY_BUTTON_ANIMATION = `${BASE_ASSETS}/play-button.json`;
export const RIPPLE_ANIMATION = `${BASE_ASSETS}/ripple.json`;
export const PULSE_ANIMATION = `${BASE_ASSETS}/pulse.json`;
export const FILE_UPLOAD_ANIMATION = `${BASE_ASSETS}/file-upload.json`;
export const ADD_ANIMATION = `${BASE_ASSETS}/add2.json`;
